// Bootstrap file that orchestrates parallel loading of translations and main app
// This file reads the locale from the HTML lang attribute (set at build time via template)
// and dynamically loads the appropriate translation file, then initializes i18n before loading the main application

import { bootstrapWithTranslations } from "@amzn/awsmp-max-translations";
import { initializeApp } from "./index";
import { applyInitialColorMode } from "./theme/colorMode";

applyInitialColorMode();

// Read locale from HTML lang attribute (set via {{locale}} template variable at build time)
const locale = document.documentElement.lang || "en";

// Bootstrap with translations and initialize the app
bootstrapWithTranslations({ locale }, ({ locale: normalizedLocale, cloudscapeMessages, polarisMessages }) => {
  initializeApp(normalizedLocale, cloudscapeMessages as any, polarisMessages as any);
});
